<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('구분')">
              <code-combo
                :data="pushTp"
                :label="$t('전체')"
                :model="searchForm.pushTpCd"
                @change="searchForm.pushTpCd = $event.cd"></code-combo>
            </el-form-item>
          </el-col>
          <el-col :md="16">
            <el-form-item :label="$t('기간')">
              <el-date-picker
                v-model="sedtm"
                type="datetimerange"
                clearable
                unlink-panels
                :style="{ width: $device.mobile ? `100%` : `360px` }"
                :default-time="['06:00:00', '23:00:00']"
                :start-placeholder="$t('날자 선택')"
                :end-placeholder="$t('날자 선택')"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('PushSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('PushAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('PushAdd') || checkAuthActionAccess('PushUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="12">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick">
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            sortable
            :fixed="!$device.mobile"
            label-class-name="data_cnt"></el-table-column>
          <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('구분')"
            prop="pushTp.nmLan"
            min-width="100"
            align="center"
            sortable></el-table-column>
          <el-table-column
            :label="$t('타이틀')"
            prop="title"
            min-width="200"
            sortable
            show-overflow-tooltip></el-table-column>
          <el-table-column
            :label="$t('발송일시')"
            prop="sendDtm"
            min-width="150"
            align="center"
            sortable></el-table-column>
        </el-table>
      </el-col>
      <el-col :md="12">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('푸시') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('구분')" :error="formError['pushTp.cd']" required>
                <code-combo :data="pushTp" :model="inputForm.pushTp" @change="inputForm.pushTp = $event"></code-combo>
              </el-form-item>

              <el-form-item :label="$t('제목')" :error="formError.title" required>
                <el-input v-model="inputForm.title" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>

              <el-form-item :label="$t('내용')" :error="formError.content" required>
                <el-input
                  type="textarea"
                  v-model="inputForm.content"
                  :autosize="{ minRows: 6, maxRows: 16 }"></el-input>
              </el-form-item>
            </el-form>

            <el-button
              v-if="checkAuthActionAccess('PushAdd') || checkAuthActionAccess('PushUp')"
              :size="size"
              @click="save"
              icon="el-icon-check"
              :disabled="btn.saveDisabled"
              style="float: right"
              class="hide-on-desktop"
              >{{ $t('저장') }}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/push'

    data.pushTp = []

    data.searchForm = this.initSearchForm()

    data.sedtm = [
      util.getDate('yyyy-MM-dd HH:mm:ss', util.dateAdd('h ', -1, new Date())),
      util.getDate('yyyy-MM-dd HH:mm:ss', util.dateAdd('h ', 1, new Date())),
    ]

    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    return data
  },
  created: function () {
    this.initPushTp()
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        startDtm: null,
        endDtm: null,
        pushTpCd: 0,
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        pushCd: 0,
        title: '',
        pushTp: { cd: null, nm: '' },
        content: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        title: '',
        'pushTp.cd': '',
        content: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val

      this.search()
    },
    // 약관 타입 데이타 조회
    initPushTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/PUSH_TP',
        null,
        function (result) {
          this.pushTp = result
        }.bind(this),
        false
      )
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()

      this.inputForm.pushTp = this.pushTp.length > 0 ? util.copyObj(this.pushTp[0]) : { cd: null, nm: '' }

      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 하나 조회
    get: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.pushCd,
        function (result) {
          this.inputForm = result
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      if (null == this.sedtm || this.sedtm.length < 2) {
        this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
        return
      }

      this.searchForm.startDtm = this.sedtm[0]

      if (this.searchForm.autoEdtm) {
        this.sedtm = [this.sedtm[0], util.getDate('yyyy-MM-dd HH:mm:ss', new Date())]
      }

      this.searchForm.endDtm = this.sedtm[1]

      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.saveDisabled = true
          this.fromDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      this.mainVue.$axios.add(
        this.url,
        this.inputForm,
        this.formError,
        function (result) {
          this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
          this.search()
        }.bind(this),
        true
      )
    },
  },
}
</script>
